import React, { useState, useEffect } from 'react';
import { driverAPI } from '../services/api';

// Rendered outside <Router>, so we use window.location for navigation.
const goTo = (path) => { window.location.href = path; };

export default function DriverLogin() {
  const [schoolCode, setSchoolCode] = useState('');
  const [busNumber, setBusNumber]   = useState('');
  const [pin, setPin]               = useState('');
  const [showPin, setShowPin]       = useState(false);
  const [busy, setBusy]             = useState(false);
  const [err, setErr]               = useState('');

  useEffect(() => {
    // Prefill from previous session on same device
    try {
      const info = JSON.parse(localStorage.getItem('gs_driver_info') || '{}');
      if (info.school_code) setSchoolCode(info.school_code);
      if (info.bus_number)  setBusNumber(info.bus_number);
    } catch {}
    // If already logged in, jump straight to driver mode
    if (localStorage.getItem('gs_driver_token')) goTo('/driver-mode');
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErr('');
    if (!schoolCode.trim() || !busNumber.trim() || !pin.trim()) {
      setErr('Please fill all fields'); return;
    }
    setBusy(true);
    try {
      const { data } = await driverAPI.login({
        school_code: schoolCode.trim(),
        bus_number:  busNumber.trim(),
        pin:         pin.trim(),
      });
      if (!data?.success) { setErr(data?.message || 'Login failed'); setBusy(false); return; }
      driverAPI.saveSession(data.data);
      goTo('/driver-mode');
    } catch (e) {
      setErr(e?.response?.data?.message || 'Login failed. Check your details.');
      setBusy(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>🚌</div>
        <h1 style={styles.title}>Driver Login</h1>
        <p style={styles.subtitle}>Enter your school code, bus number and PIN</p>

        <form onSubmit={handleLogin}>
          <label style={styles.label}>School Code</label>
          <input
            style={styles.input}
            type="text"
            value={schoolCode}
            onChange={e => setSchoolCode(e.target.value.toUpperCase())}
            placeholder="e.g. GEETHAM"
            autoCapitalize="characters"
            autoCorrect="off"
          />

          <label style={styles.label}>Bus Number / Registration No</label>
          <input
            style={styles.input}
            type="text"
            value={busNumber}
            onChange={e => setBusNumber(e.target.value.toUpperCase())}
            placeholder="e.g. BUS-01 or AP08TS1234"
            autoCapitalize="characters"
            autoCorrect="off"
          />

          <label style={styles.label}>PIN</label>
          <div style={{ position: 'relative' }}>
            <input
              style={{ ...styles.input, paddingRight: 60, letterSpacing: 8, fontSize: 22 }}
              type={showPin ? 'text' : 'password'}
              value={pin}
              onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 8))}
              inputMode="numeric"
              placeholder="••••"
              maxLength={8}
            />
            <button
              type="button"
              onClick={() => setShowPin(v => !v)}
              style={styles.eye}
            >{showPin ? '🙈' : '👁'}</button>
          </div>

          {err && <div style={styles.err}>{err}</div>}

          <button type="submit" disabled={busy} style={styles.btn}>
            {busy ? 'Logging in…' : 'Log In'}
          </button>
        </form>

        <div style={styles.foot}>
          <a href="/" style={styles.link}>← Back to main app</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg,#0b3d91 0%,#1976d2 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 16, fontFamily: 'system-ui,-apple-system,sans-serif',
  },
  card: {
    background: '#fff', borderRadius: 20, padding: '32px 28px',
    width: '100%', maxWidth: 400,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  logo: { fontSize: 56, textAlign: 'center', marginBottom: 8 },
  title: { margin: 0, textAlign: 'center', fontSize: 28, color: '#0b3d91' },
  subtitle: { margin: '4px 0 24px', textAlign: 'center', color: '#666', fontSize: 14 },
  label: { display: 'block', marginTop: 14, marginBottom: 6, fontWeight: 600, color: '#333', fontSize: 14 },
  input: {
    width: '100%', boxSizing: 'border-box',
    padding: '14px 14px', fontSize: 18,
    border: '2px solid #e0e0e0', borderRadius: 10, outline: 'none',
  },
  eye: {
    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
    background: 'transparent', border: 'none', fontSize: 22, cursor: 'pointer',
  },
  err: { marginTop: 12, padding: 10, background: '#fee', color: '#b00', borderRadius: 8, fontSize: 14 },
  btn: {
    marginTop: 20, width: '100%', padding: '16px',
    background: '#0b3d91', color: '#fff', border: 'none', borderRadius: 12,
    fontSize: 18, fontWeight: 700, cursor: 'pointer',
  },
  foot: { textAlign: 'center', marginTop: 20 },
  link: { color: '#1976d2', textDecoration: 'none', fontSize: 14 },
};
